module.exports = __webpack_public_path__ + "img/fcb-logo-ug.4ab7edf4.png";